<template>
  <div id="app">
    <router-view/>
    <EperqrCode></EperqrCode>
    <BackTop :bottom="130">
       <div class="top">
         <span class="txt">TOP</span>
       </div>
    </BackTop>
    <eperAddCartSuccMessage></eperAddCartSuccMessage>
  </div>
</template>

<script>
  const EperqrCode = () => import('@/components/public/qrCode');
  const eperAddCartSuccMessage = () => import('@/components/public/eperAddCartSuccMessage');
  export default {
    name: 'App',
    data(){
    return {
      i18n:null
    }
  },
    components: {EperqrCode,eperAddCartSuccMessage},
    created:async function (){
    await this.init();
    await this.GetPromBackGround();
  },
  methods:{
    // 查看是否有背景图需要展示
    GetPromBackGround(){
      this.$store.dispatch("GetPromBackGround").then(res=>{
        if(res.Code == 200 && (res.Data.LeftPic != "" || res.Data.RightPic != "" || res.Data.TopPic != "")){
          localStorage.setItem("promBackGround",JSON.stringify(res.Data));
        }else{
          localStorage.removeItem("promBackGround");
        }
      })
    },
    // Version:指定版本
    CheckLangVersion:async function () {
	    let state;
	    await this.$store.dispatch("CheckVersion", {
		    isSign: true,
		    ProjectCode: "NOGOGO_PC",
		    Version: "0.0.1"
	    }).then(res => {
		    let Data = JSON.parse(res.Data);
		    let localLangVersion = JSON.parse(localStorage.getItem("langVersion"));
		    let langData = JSON.parse(localStorage.getItem("langData"));
		    // 本地没有储存过版本号 新用户
		    // 本地储存版本号和云端对不上 需要更新数据
		    if (localLangVersion && localLangVersion.versionNumber == Data.versionNumber && Data.timestamp == localLangVersion.timestamp && langData) {
			    state = false;
		    }else{
			    localStorage.setItem("langVersion",res.Data);
			    state = true;
		    }
	    })
	    return state;
    },
    // 获取语言数据
    GetLangData:async function () {
	    let localLangVersion = JSON.parse(localStorage.getItem("langVersion"));
	    await this.$store.dispatch("GetLang", {
		    isSign: true,
		    ProjectCode: "NOGOGO_PC",
		    Version: localLangVersion.versionNumber ? localLangVersion.versionNumber : ""
	    }).then(res => {
		    const Data = JSON.parse(res.Data);
		    const version = JSON.parse(res.Data).version;
		    const content = JSON.parse(Data.content);
		    // console.log("语言数据",Data,version,content);
		    // uni.setStorageSync("langData",content);
		    localStorage.setItem("langData",JSON.stringify(content));
		    this.i18n = content;

	    })
    },
    init:async function (){
      try {
        let IsUpdateLanguageData = await this.CheckLangVersion();
        let langData = JSON.parse(localStorage.getItem("langData"));
        
        if(IsUpdateLanguageData){
          await this.GetLangData();
        }else if(langData){
          this.i18n = langData;
        }else{
          await this.GetLangData();
        }
        if(this.i18n && this.i18n.EN && this.i18n.ZH && this.i18n.FR){
          const {EN,ZH,FR} = this.i18n;
          const newENMessages = Object.assign(this._i18n.getLocaleMessage('en_us'), EN);
          const newZHMessages = Object.assign(this._i18n.getLocaleMessage('zh_cn'), ZH);
          const newFRMessages = Object.assign(this._i18n.getLocaleMessage('fr_fr'), FR);
          this._i18n.setLocaleMessage("en_us", newENMessages);
          this._i18n.setLocaleMessage("zh_cn", newZHMessages);
          this._i18n.setLocaleMessage("fr_fr", newFRMessages);
        }
      } catch (error) {
        console.error('初始化语言数据失败:', error);
        // 错误处理：使用默认语言设置
        if(this._i18n){
          const defaultMessages = {}
          this._i18n.setLocaleMessage("en_us", defaultMessages);
          this._i18n.setLocaleMessage("zh_cn", defaultMessages);
          this._i18n.setLocaleMessage("fr_fr", defaultMessages);
        }
      }
    },
    checkLang() {
      let lang = localStorage.getItem('lang')
      let locale = 'en_us'
      if(lang) {
        if(lang == 1) {
          locale = 'zh_cn'
        } else if (lang == 2) {
          locale = 'en_us'
        } else {
          locale = 'fr_fr'
        }
        return locale;
      }
      return locale;

    }
  }
  }
</script>

<style lang="scss">
  @import "./style/base.scss";
  @import "./style/color.scss";
  @import "./fonts/font.css";
  .word {
    font-family: "EperFontBold", Microsoft YaHei, PingFang SC, Open Sans, Hiragino Sans GB, Heiti SC, monospace !important;
  }
  html,body {
    font-family: "EperFontBold", Microsoft YaHei, PingFang SC, Open Sans, Hiragino Sans GB, Heiti SC, monospace !important;
  }
  .top {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: $c_6DB;
    color: $c_fff;
    position: relative;
    &::after {
        content: "";
        display: block;
        width: 10px;
        height: 10px;
        transform: rotate(-45deg);
        box-sizing: border-box;
        border-top: 2px solid #ffffff;
        border-right: 2px solid #ffffff;
        cursor: pointer;
        margin: 0 auto;
        position: absolute;
        top: 10px;
        left: 18px;
        transition: transform 150ms linear;
    }
    .txt {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 6px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue